import React from "react";
import "./styles.scss";
import SideBar from "../components/side-bar/SideBar";
import NewSubSection from "../components/sub-section/SubSection";
import { useParams } from "react-router-dom";
import ConfirmationModal from "../../../../../shared/components/confirmationModal/ConfirmationModal";
import WorkshopSummary from "../components/workshop-summary/WorkshopSummary";
import PageHeader from "../../../components/page-header/PageHeader";
import {
  useWorkShop,
  WorkshopProvider,
} from "../../../../../contexts/workshop-context/WorkshopContext";

const Workshop = () => {
  const workshop = useWorkShop();

  return (
    <div className="new-workshop-wrapper">
      <div className="new-workshop-sidebar">
        <SideBar />
      </div>
      <div className="new-workshop-content">
        {workshop.selectedSubSection?.orderNo !== -1 ? (
          <>
            <PageHeader title="Create New Subsection" />
            <div
              style={{
                padding: "25px",
                paddingTop: "200px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <NewSubSection />
              </div>
            </div>
          </>
        ) : (
          <WorkshopSummary />
        )}
      </div>
      <ConfirmationModal
        children={{
          headerText: workshop.model.title,
          bodyText: workshop.model.content,
          confirmButtonText: "I'm sure",
          cancelButtonText: "Cancel",
          confirmButtonColor: "blue",
        }}
        show={workshop.model.show}
        onCancel={workshop.model.onCancel}
        onConfirm={workshop.model.onConfirm}
        loading={false}
      />
    </div>
  );
};

interface IProps{
  isArchived:boolean
  isDireactArchived:boolean;
}

const UpdateWorkshop = (props:IProps) => {
  const { id } = useParams() as any;

  return (
    <WorkshopProvider isArchived={props.isArchived} isDireactArchived={props.isDireactArchived} workshopId={id}>
      <Workshop />
    </WorkshopProvider>
  );
};

export default UpdateWorkshop;
